import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

function RedirectApp() {
  useEffect(() => {
    window.location.href = "https://controltower.cloudingenuity.com";
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', 
      justifyContent: 'center', 
      alignItems: 'center',
      flexDirection: 'column' 
    }}>
      <h1>Cloud Ingenuity Service Desk</h1>
      <p>Redirecting to Control Tower...</p>
      <p>If you're not redirected, <a href="https://controltower.cloudingenuity.com">click here</a></p>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RedirectApp />);

reportWebVitals();